import {
	getAnalytics,
	logEvent as firebaseLogEvent,
} from "@firebase/analytics";
import { initializeApp } from "@firebase/app";

import { firebaseConfig } from "../firebase";
import { AccountService } from "../hooks/useAccount";

const firebaseApp = initializeApp(firebaseConfig);
const firebaseAnalytics = getAnalytics(firebaseApp);

export const eventNames = Object.freeze({
	purchaseOnsiteCourseFull: "purchase_onsite_course_full",

	manageFinances: "manage_finances",

	submitPilotCertificate: "submit_pilot_certificate",
	submitGovernmentId: "submit_government_id",
	submitEmergencyContact: "submit_emergency_contact",

	setGeneralAvailability: "set_general_availability",
	setSameDayNotice: "set_same_day_notice",
	setTimeBreak: "set_time_break",
	setSchedulingFee: "set_scheduling_fee",

	searchCourse: "search_course",

	rescheduleByInstructor: "reschedule_by_instructor",

	updateStudentProgress: "update_student_progress",

	purchasePremiumPackage: "purchase_premium_package",

	clickSeeThreeDPricing: "click_see_three_d_pricing",
});

export type TEventNames = (typeof eventNames)[keyof typeof eventNames];

export function logEvent(
	eventName: TEventNames,
	params?: { [key: string]: any },
) {
	firebaseLogEvent(firebaseAnalytics, eventName, {
		userCode: (AccountService.savedAccount as any)?.userId ?? null,
		userId: (AccountService.savedAccount as any)?.id ?? null,
		email: (AccountService.savedAccount as any)?.email ?? null,
		...(params ?? {}),
	});
}
